import AlertContainer from './AlertContainer';

export default AlertContainer;
